import { useEffect } from "react";
import { IntegrationTestsView } from "./IntegrationTestsView";
import "./PlatformAdmin.css";

const noLogin = () => {};
export default function IntegrationTestsPage() {
  const query = new URLSearchParams(window.location.search);
  const liveSeq = query.get("control") === "1" ? Number(query.get("live")) : 0;
  useEffect(() => {
    const previous = document.title;
    document.title = "통합 부하 테스트 | 팬버드";
    return () => {
      document.title = previous;
    };
  }, []);
  return (
    <main className="pa-root pa-test-standalone">
      <header className="pa-test-page-header">
        <a href="/integration-tests">
          fanbird<span>.</span>
        </a>
        <span>통합 부하 테스트</span>
      </header>
      {query.get("control") === "1" ? (
        Number.isSafeInteger(liveSeq) && liveSeq > 0 ? (
          <IntegrationTestsView onAuth={noLogin} initialLive={liveSeq} />
        ) : (
          <p role="alert">테스트 라이브 번호를 확인해주세요.</p>
        )
      ) : (
        <IntegrationTestsView onAuth={noLogin} />
      )}
    </main>
  );
}
